import { Avatar, Box, MenuItem, Select, Stack } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomAuto from "../../components/autocomplete/CustomAuto";
import CommonModel from "../../components/dialog/Common";
import { DiscoverySearchInfluencerButton, getSearchdata, setSearchdata } from "../../utils/common";
import { getInfluencerListFordashboard } from "./action";
import { updateDashboard } from "./dashboardSlice";
import NestedDropdown from "./NestedDropdown";
import { PLATFORMS_IMGS_LIST } from "../../utils/constant";
const SearchBox = () => {
    const { plateforms } = useSelector((state) => state.commonSlice);
    const { exceedMsg, filters,limit } = useSelector((state) => state.dashboardSlice);
    const [value, setValue] = useState({ platform: "Instagram", categories: [] });
    const dispatch = useDispatch();
    const [openDropdown, setOpenDropdown] = useState(false);
    useEffect(() => {
        let data = getSearchdata();
        let cat = data?.categories ? data?.categories?.map((v) => {
            return { title: v };
        }) : [];
        setValue({ ...filters, platform: (data?.platform || "Instagram"), categories: cat, });
    }, []);
    const handleSubmit  = (values)=>{
                let categories = values?.categories?.map((v) => v.title) || values.categories
                const jsonString = JSON.stringify({ platform: values.platform, categories: categories });
                setSearchdata(jsonString);
                dispatch(
                    updateDashboard({
                        filters: { ...filters, platform: values.platform, categories: categories },
                        search: "",
                        list: [],limit:limit || 20,totalCount:0,page:1,showLoading:true,
                    }),
                );
                dispatch(getInfluencerListFordashboard());
    }
    return <>
        <Formik
            initialValues={value ? value : { platform: "Instagram", categories: [] }}
            enableReinitialize={true}
            validateOnChange={true}
            onSubmit={handleSubmit}
        >
            {({
                handleChange,
                handleSubmit,
                values,
            }) => {

                return (
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit(e);
                        }}
                    >

                        <Box className="searchBlockInflu" sx={{ position:'revert',width: '100% !important', borderRadius: "0", border: '0', zIndex: '10',boxShadow: 'none', borderTop: '1px solid rgba(170, 170, 170, 0.3)', borderBottom: '1px solid rgba(170, 170, 170, 0.3)' }} >
                            <Stack direction="row" sx={{padding:'0',justifyContent:'space-between'}}>
                                <Box bgcolor="transparent" >
                                    <Select
                                        className="searchPlatform"
                                        name="platform"
                                        value={values.platform}
                                        onChange={handleChange}
                                        displayEmpty
                                        open={openDropdown}
                                        onOpen={() => setOpenDropdown(true)}
                                        onClose={() => setOpenDropdown(false)}
                                        IconComponent={(props) => <CustomDropdownIcon {...props} open={openDropdown} />}
                                        sx={{
                                            minWidth: "fit-content",
                                            borderRadius: "8px",
                                            background: "white",
                                            position: "relative",
                                            overflow: "hidden",
                                            height: '40px',
                                            "& .MuiSelect-select": {
                                                padding: '0 0px 0 13px !important',
                                                width:'68px'
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "transparent",
                                            },
                                            "::before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                padding: "2px",
                                                borderRadius: "8px",
                                                background: "linear-gradient(90deg, #FFCC70, #C850C0, #4158D0)",
                                                "-webkit-mask":
                                                    "linear-gradient(white, white) content-box, linear-gradient(white, white)",
                                                "-webkit-mask-composite": "destination-out",
                                                maskComposite: "exclude",
                                                pointerEvents: 'none',
                                                outline: 0,
                                            }, "&.Mui-focused, &:hover, &:focus-within,&:focus-visible": {
                                                "::before": {
                                                    opacity: 1,
                                                },
                                            },
                                            padding: '0px',
                                            outline: 0,
                                        }}
                                        renderValue={(selected) => (
                                            selected ? (
                                                <img
                                                    alt={selected}
                                                    width="24" height="24"
                                                    src={PLATFORMS_IMGS_LIST[selected]}
                                                />
                                            ) : "Select Platform"
                                        )}
                                        MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                height:'85px',
                                                width:'130px',
                                                padding:'0px !important',
                                                borderRadius: "12px",
                                                boxShadow: '0px 4px 12px 0px #0000001F',
                                                mt: 1,
                                                "& .MuiMenuItem-root": {
                                                  color: "black",
                                                },
                                              },
                                            },
                                          }}
                                    >
                                        {plateforms.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item}
                                                sx={{ display: "flex", alignItems: "center", gap: 1, padding: "4px 8px" }}
                                            >
                                                <Avatar
                                                    alt={item}
                                                    src={PLATFORMS_IMGS_LIST[item]}
                                                    sx={{ width: 24, height: 24, overflow: 'visible' }}
                                                />
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>

                                <Box className="searchText" style={{ width: 'calc(100% - 150px)', paddingLeft: '10px', fontSize: '15px' }}>
                                    <CustomAuto type="list" handleChange={(e, newValue) => {
                                        handleChange({
                                            target: { name: "categories", value: newValue },
                                        });
                                        handleSubmit(values);
                                    }} values={values} />


                                </Box>
                                <Box
                                    sx={{
                                        zIndex: 0,
                                        display: 'inline-flex', width: '120px', justifyContent: 'flex-end'
                                    }}
                                >
                                 <DiscoverySearchInfluencerButton/>
                                </Box>
                            </Stack>
                            <div className="search-parent-second">
                                <NestedDropdown parentFormValues={values} parentFormHandleChange={handleChange}/>
                            </div>
                        </Box>
                    </Form>
                );
            }}
        </Formik>
        <CommonModel
            open={exceedMsg !== ""}
            handleDialogClose={() => dispatch(updateDashboard({ exceedMsg: "" }))}
            dialogTitle={"Insufficient Credits"}
            dialogPara={exceedMsg}
            nvYes={"Close"}
            yesHandle={() => dispatch(updateDashboard({ exceedMsg: "" }))}
        />
    </>
}
export default SearchBox;
const CustomDropdownIcon = ({open,...props}) => {
    return(
        <div {...props} style={{padding:'0',marginRight:'10px'}}>
  <svg style={{
      transition: "transform 0.3s ease",
      border:'0px solid red',padding:'0',margin:'0',height:'14px',width:'14px',
      transform: open ? "rotate(0deg)" : "rotate(180deg)",
    }} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 6L6 1" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 1L1 6" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
    </div>
  )};